import * as actionTypes from  "../actions/ScopesActions"

const initialState = {
  Loading: false,

  scopesList: [],

  getUser :[],
  scopesRecord: [],
  scopesDropdownList: [],
  workspaceAttachmentList: [],
  validation_error: "",
  attachment_validation_error: "",
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
  closeModal:false,
  session: null, // Add session state
};
const ScopesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SCOPES_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };
  
    case actionTypes.SCOPES_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        scopesList: action.scopesList,
        showUpdateForm: false,
        showViewPage: false,
        scopesRecord: [],
      };
 
    case actionTypes.SCOPES_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        scopesRecord: [],
      };
    case actionTypes.SCOPES_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        scopesRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.SCOPES_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        scopesDropdownList: action.scopesDropdownList,
      };
    case actionTypes.SCOPES_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_SCOPES_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.REDIRECT_TO_SCOPES_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        scopesRecord: [],
      };

  

    default:
      return state;

   
  }
};

export default ScopesReducer;
